exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fullscreen-spinner-blackout{position:fixed;left:0;top:0;width:100%;height:100%;z-index:9999;background:rgba(0,0,0,.5)}.fullscreen-spinner{position:fixed;top:50%;left:50%;margin-left:-36px}.fullscreen-spinner-text{position:fixed;width:100%;text-align:center;top:35%;color:#fff;text-shadow:3px 3px 1px #333}.fade-enter-active,.fade-leave-active{transition:opacity .5s}.fade-enter,.fade-leave-to{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-1c9be226","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/commons/FullscreenSpinner.vue
// module id = 204
// module chunks = 0